import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatListModule} from '@angular/material/list';
import { TemplateFilesListComponent } from './template-files-list/template-files-list.component';
import { TemplateEditorDialogComponent } from './template-editor-dialog/template-editor-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { DataModule } from '@data/data.module';

@NgModule({
  declarations: [
    TemplateFilesListComponent,
    TemplateEditorDialogComponent
  ],
  imports: [
    CommonModule,
    DataModule,
    MatButtonModule,
    MatDialogModule,
    MatListModule
  ],
  exports: [
    TemplateFilesListComponent,
    TemplateEditorDialogComponent
  ]
})
export class DocumentEditorModule { }
